import { LucideIcon } from "lucide-react";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const FeatureCard = ({ icon: Icon, title, description }: FeatureCardProps) => (
  <div className="flex flex-col items-center p-6 bg-card rounded-2xl shadow-lg hover:shadow-xl transition-shadow min-w-[230px]">
    <span className="w-12 h-12 mb-3 rounded-full bg-teal-50 dark:bg-teal-900 flex items-center justify-center">
      <Icon className="w-7 h-7 text-teal-500 dark:text-teal-300" />
    </span>
    <h3 className="text-lg font-semibold mb-1 text-foreground">{title}</h3>
    <p className="text-sm text-muted-foreground text-center">{description}</p>
  </div>
);

export default FeatureCard;
